import React from 'react';
import {
  Form,
  Label,
  FormGroup,
} from 'reactstrap';
import PropTypes from 'prop-types';

import { FormField, SelectFormField, CustomFormInput } from '../../../../../utils/FormFields';
import CircularProggess from '../../../../CircularProgress/CircularProgress';
import { BankAccountStatus } from '../../../../Profile/Account/types';

function PersonBankAccount({
  person, changedPerson, showChanges, currencies, fetchFile,remove
}) {
  const editBankAccount = changedPerson.PersonBankAccount[0];
  let compareBankAccount;
  person.PersonBankAccount? person.PersonBankAccount.map((b) => {
    if (parseInt(b.PersonBankAccountItemId, 10) === parseInt(editBankAccount.PersonBankAccountItemId, 10)) {
      compareBankAccount = b;
    }
    return {};
  }):null;
  let color = 'black';
  if (showChanges) {
    if (remove) {
      color = 'red';
    } else if (compareBankAccount) {
      color = '#36a9e1';
    } else {
      color = 'green';
    }
  }

  const getFile = (file) => {
    const body = {
      fileId: file.ArchiveTemporalFileId
    }
    fetchFile(body, (response) => {
      var a = document.createElement('A');
      a.href = `data:application/octet-stream;base64,${response.blobfile}`;
      a.download = `${file.ArchiveName}.${file.ArchiveExtension}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    })
  }
  return (
    <Form>
      <Label style={{
        fontWeight: 500,
        fontSize: '20px',
        display: 'block',
        color,
      }}
      >
        {showChanges
          ? (
            <React.Fragment>
              {editBankAccount.PersonBankAccountItemId > 0
                ? (
                  <React.Fragment>
                    {remove ? 'Delete Bank Account' : 'Edit Bank Account'}
                  </React.Fragment>
                )
                : 'New Bank Account'}
            </React.Fragment>
          )
          : 'Actual Account'}
      </Label>
      {showChanges
        ? (
          <FormGroup tag="fieldset">
            {!editBankAccount.DeleteBankAccount
              && (
                <FormToShow
                  bankAccount={editBankAccount}
                  refBankAcc={compareBankAccount}
                  currencies={currencies}
                  getFile = {getFile}
                />
              )}
          </FormGroup>
        )
        : (
          <FormGroup tag="fieldset">
            {compareBankAccount
              && (
                <FormToShow
                  bankAccount={compareBankAccount}
                  currencies={currencies}
                  getFile = {getFile}
                />
              )}
          </FormGroup>
        )}
    </Form>
  );
}

PersonBankAccount.propTypes = {
  changedPerson: PropTypes.object.isRequired,
  person: PropTypes.object.isRequired,
  showChanges: PropTypes.bool.isRequired,
  currencies: PropTypes.array,
  fetchFile: PropTypes.func,
  remove: PropTypes.bool.isRequired,
};

PersonBankAccount.defaultProps = {
  currencies: undefined,
};

export default PersonBankAccount;

const FormToShow = ({ bankAccount, refBankAcc, currencies, getFile }) => (
  <React.Fragment>
    {bankAccount.BankAccountItemId > 0 && (
      <FormField
        name="BankAccountItemId"
        value={bankAccount.BankAccountItemId}
        label="Id"
      />
    )}
    <FormField
      name="BankAccountName"
      value={bankAccount.PersonBankAccountName}
      label="Name"
      changedColor={refBankAcc && bankAccount.PersonBankAccountName !== refBankAcc.PersonBankAccountName}
    />
    <FormField
      name="PersonBankAccountPersonalName"
      value={bankAccount.PersonBankAccountPersonalName}
      label="Personal Name"
      changedColor={refBankAcc
        && bankAccount.PersonBankAccountPersonalName !== refBankAcc.PersonBankAccountPersonalName}
    />
    <FormField
      name="PersonBankAccountHolders"
      value={bankAccount.PersonBankAccountHolders}
      label="Holders"
      changedColor={refBankAcc && bankAccount.PersonBankAccountHolders !== refBankAcc.PersonBankAccountHolders}
    />
    <FormField
      name="PersonBankAccountBranch"
      value={bankAccount.PersonBankAccountBranch}
      label="Branch"
      changedColor={refBankAcc
        && parseInt(bankAccount.PersonBankAccountBranch, 10)
        !== parseInt(refBankAcc.PersonBankAccountBranch, 10)}
      type="number"
      dataTypeDecimalName="currency"
    />
    <FormField
      name="PersonBankAccountNumber"
      value={bankAccount.PersonBankAccountNumber}
      label="Number"
      changedColor={refBankAcc
        && parseInt(bankAccount.PersonBankAccountNumber, 10)
        !== parseInt(refBankAcc.PersonBankAccountNumber, 10)}
    />
    <FormField
      name="PersonBankAccountType"
      value={bankAccount.PersonBankAccountType}
      label="Type"
      changedColor={refBankAcc
        && bankAccount.PersonBankAccountType !== refBankAcc.PersonBankAccountType}
    />
    {currencies ? (
      <SelectFormField
        label="PersonBankAccountCurrency"
        changedColor={refBankAcc
          && parseInt(bankAccount.PersonBankAccountCurrency, 10)
          !== parseInt(refBankAcc.PersonBankAccountCurrency, 10)}
        selectItems={currencies}
        getSelectItemId={(i) => i.currencyId}
        getSelectItemName={(i) => i.currencyISO}
        value={bankAccount.PersonBankAccountCurrency}
        name=""
      />
    ) : <CircularProggess sm />}
    <FormField
      name=""
      value={bankAccount.PersonBankAccountIsDepositInterest ? 'Yes' : 'No'}
      label="Default Instruction: "
      changedColor={refBankAcc
        && bankAccount.PersonBankAccountIsDepositInterest !== refBankAcc.PersonBankAccountIsDepositInterest}
    />
    <FormField
      name=""
      value={bankAccount.PersonBankAccountFundIncomesOnly ? 'Yes' : 'No'}
      label="Fund Incomes only: "
      changedColor={refBankAcc
        && bankAccount.PersonBankAccountFundIncomesOnly !== refBankAcc.PersonBankAccountFundIncomesOnly}
    />
    <FormField
      name="PersonBankAccountObs"
      value={bankAccount.PersonBankAccountObs}
      label="Observation"
      changedColor={refBankAcc
        && bankAccount.PersonBankAccountObs !== refBankAcc.PersonBankAccountObs}
      type="textarea"
    />
    <SelectFormField
        label="Status"
        changedColor={refBankAcc
          && bankAccount.PersonBankAccountStatus !== refBankAcc.PersonBankAccountStatus}
          selectItems={Object.keys(BankAccountStatus)}
        getSelectItemId={i => i}
        getSelectItemName={i => BankAccountStatus[i]}
        value={bankAccount.PersonBankAccountStatus}
        name=""
      />
     
    {bankAccount.Archives !== undefined  && bankAccount.Archives.map((item) => (
      <CustomFormInput label="File">
      
      {item.ArchiveTemporalFileId > 0 ? 
        <a onClick= {() => getFile(item)} style = {{cursor:'pointer'}}>
          {`${item.ArchiveName}.${item.ArchiveExtension}`}
        </a> 
      : /* Este es el caso para las alertas que tienen los blobs en el objeto item */
        <a href={`data:application/octet-stream;base64,${item.ArchiveBlob}`} download={`${item.ArchiveName}.${item.ArchiveExtension}`}>
          {`${item.ArchiveName}.${item.ArchiveExtension}`}
        </a> 
      }
    
   </CustomFormInput>
       ))}
       
  </React.Fragment>
);

FormToShow.propTypes = {
  bankAccount: PropTypes.object.isRequired,
  refBankAcc: PropTypes.object,
  currencies: PropTypes.array,
  getFile: PropTypes.func
};

FormToShow.defaultProps = {
  refBankAcc: undefined,
  currencies: undefined,
};
